import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/tumour-research/mammography";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	mammography: {
		id: "ktx.mammography.title",
		defaultMessage: "Mammográfia"
	},
	result: {
		id: "ktx.mammography.field.result",
		defaultMessage:
			"Eredmény (Kérjük 40 éves kor feletti női páciens esetén mindenképpen töltse ki az űrlapot)"
	},
	comment: {
		id: "ktx.mammography.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_mammography",
	value: {
		schemaId: "mammography",
		title: messages.mammography,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
